/*
 * Copyright (C) 2019 Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor ()
  {
    this.collection = new Map();
  }


  add (zone, user, value, type)
  {
    this.collection.set(zone.getID(), { user, value, type });
  }


  delete (zone)
  {
    this.collection.delete(zone.getID());
  }


  getValue (user)
  {
    let value = 0;

    for (const influence of this.collection.values())
    {
      if (influence.user === user)
      {
        value += influence.value;
      }
    }

    return value;
  }


  getSortedTotals ()
  {
    const reduceCallback = (results, { user, value }) =>
    {
      results[user] = (results[user] || 0) + value;

      return results;
    };

    const results = this.collection.values().reduce(reduceCallback, {});

    const mapCallback = ([user, value]) => ({ user, value });
    const sortCallback = (lhs, rhs) => (lhs.value - rhs.value);

    return Object.entries(results).map(mapCallback).sort(sortCallback);
  }


  getBySource (source)
  {
    return this.collection.get(source.getID());
  }


};
